import { IChatItem } from "../models/ChatItem";
import { IMessagePreview } from "../models/MessagePreview";
import { IMessageItem, ISendingMessage } from "../models/MessageItem";
import { IChannelItem, OperatorPriorityType } from "../models/ChannelItem";
import { IOperatorItem } from "../models/OperatorItem";
import { IQuickAnswer } from "../models/QuickAnswer";
import { HubConnection } from "@microsoft/signalr";
import { ISetting } from "src/app/setting/~store/models/setting";
import { TopicPairContentType } from "src/app/nlp/~store/models/enums/TopicPairContentType";
import { IChatSummaryItem } from "../models/ChatSummaryItem";

export interface IChatItemsState {
    chatItems: IChatItem[];
    chatMessagePreview: IMessagePreview[];
    silentChatsId: number[];
    selectedChat: IChatItem | undefined;
    canSendMessage: boolean;
    isChatVisible: boolean;
    isReceivingChats: boolean;
    operatorStatus: OperatorStatusType;
    closeChatCategories: string[];
    closeChatSubjects: string[];
    customChatTagsSetting: ISetting | undefined,
    isGettingCloseChatSubjects: boolean;
    reconnectingStatus: boolean;
    hubConnection: HubConnection;
    selectedChatId: number;
    messages: IMessageItem[];
    sendingMessage: ISendingMessage | null;
    operatorCurrentChatText: string;
    operatorCurrentMessageContentType: TopicPairContentType;
    operatorCurrentChatQuote: IQuote | null;
    operatorName: string;
    operatorAvatarId: string | null;
    operatorId: number;
    contactName: string;
    contactExternalId: string;
    isContactOnline: boolean | undefined;
    contactAvatarId: string | null;
    contactTags: string[];
    channelSettings: ISetting | undefined;
    operatorChannels: IChannelItem[];
    isReceivingOnlineOperators: boolean;
    onlineOperators: IOperatorItem[];
    isReceivingOnlineOperatorsToInvite: boolean;
    isReceivingAvailableTiers: boolean;
    availableTiers: OperatorPriorityType[];
    availableContactTags: string[];
    updatingContactTags: boolean;
    onlineOperatorsToInvite: IOperatorItem[];
    botsTransferTo: IOperatorItem[];
    isMessageEditing: boolean;
    messageToEdit: IMessageItem;
    chatHistory: IChatHistoryContainer;
    searchChatHistoryByMessenger: boolean;
    quickAnswersContainer: IQuickAnswerContainer;
    chatsDrafts: Map<number, IChatDraft>;
    sendingFilesCount: number;
    operatorsStatusList: IOperatorStatusViewModel[];
    isChatClosing: boolean;
    isReceivingChat: boolean;
    isSendingMessage: boolean;
    chatSummary: IChatSummaryItem | null;
    isReceivingChatSummary: boolean;
}

export interface IChatDraft
{
    text?: string;
    quote: IQuote | null;
}

export interface IQuote
{
    text: string,
    author: string | null,
}

export enum OperatorStatusType {
    Online = 1,
    Pause = 2,
    Offline = 3,
    Pause1 = 401,
    Pause2 = 402,
    Pause3 = 403,
    Pause4 = 404,
    Pause5 = 405,
    Pause6 = 406,
    Pause7 = 407,
    Pause8 = 408,
    Pause9 = 409,
    Pause10 = 410
}

export interface IChatHistoryContainer {
    canGetMoreBefore: boolean,
    canGetMoreAfter: boolean,
    gotBefore: number,
    gotAfter: number,
    isReceivingHistory: boolean
}

export interface IQuickAnswerContainer {
    quickAnswers: IQuickAnswer[],
    isReceivingQuickAnswers: boolean
}
 
export interface IOperatorStatusViewModel {
    operatorId: number,
    name: string,
    status: OperatorStatusType,
    setOn: Date
}